"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBorrowingAmount = useBorrowingAmount;
var _react = require("react");
var _reactRedux = require("react-redux");
var _bignumber = require("bignumber.js");
var _useOrderProducts2 = require("../common/useOrderProducts");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var _numberFormatter = require("../../../helpers/numberFormatter");
/**
 * Calculates the borrowing amount for the selected instrument for margin trading.
 * @param {string} formName Name of the form to get the values from
 * @returns {{ value: number; formatted: string; symbol: string; }}
 */
function useBorrowingAmount(formName) {
  var _ref, _product2$rawBalance, _product1$rawBalance;
  var _useOrderProducts = (0, _useOrderProducts2.useOrderProducts)(),
    product1 = _useOrderProducts.product1,
    product2 = _useOrderProducts.product2;
  var formValues = (0, _reactRedux.useSelector)(function (state) {
    var _state$form$formName;
    return (_state$form$formName = state.form[formName]) === null || _state$form$formName === void 0 ? void 0 : _state$form$formName.values;
  });
  var isBuy = formValues.side === _orderEntryFormConstants.buyValue;
  var value = (_ref = isBuy ? formValues === null || formValues === void 0 ? void 0 : formValues.value : formValues === null || formValues === void 0 ? void 0 : formValues.quantity) !== null && _ref !== void 0 ? _ref : 0;
  var balance = isBuy ? (_product2$rawBalance = product2 === null || product2 === void 0 ? void 0 : product2.rawBalance) !== null && _product2$rawBalance !== void 0 ? _product2$rawBalance : 0 : (_product1$rawBalance = product1 === null || product1 === void 0 ? void 0 : product1.rawBalance) !== null && _product1$rawBalance !== void 0 ? _product1$rawBalance : 0;
  var decimalPlaces = isBuy ? product2 === null || product2 === void 0 ? void 0 : product2.DecimalPlaces : product1 === null || product1 === void 0 ? void 0 : product1.DecimalPlaces;
  var symbol = isBuy ? product2 === null || product2 === void 0 ? void 0 : product2.Product : product1 === null || product1 === void 0 ? void 0 : product1.Product;
  return (0, _react.useMemo)(function () {
    var borrowingAmount = _bignumber.BigNumber.max(0, (0, _bignumber.BigNumber)(value).minus(balance));
    return {
      value: borrowingAmount.dp(decimalPlaces).toNumber(),
      formatted: (0, _numberFormatter.formatNumberToLocale)(borrowingAmount, decimalPlaces),
      symbol: symbol
    };
  }, [balance, decimalPlaces, value, symbol]);
}